import script from "./PresenceDialogChanges.vue?vue&type=script&setup=true&lang=js"
export * from "./PresenceDialogChanges.vue?vue&type=script&setup=true&lang=js"

import "./PresenceDialogChanges.vue?vue&type=style&index=0&id=34ab5e4a&lang=scss&scoped=true"
import "./PresenceDialogChanges.vue?vue&type=style&index=1&id=34ab5e4a&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34ab5e4a"]])

export default __exports__